import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    position: relative;
    flex-flow: column nowrap;
    height: 100%;

    .terms-of-usage {
        width: 80%;
        height: 90%;
        margin: auto;

        iframe {
            width: 100%;
            height: 100%;
        }

        div {
            color: white;
            display: flex;
            justify-content: center;
        }

        .terms-control {
        }
    }

    .ranking-modal {
        overflow-y: auto;
        width: 100%;
        padding: 0 40px;
    }

    @media (min-width: 650px) {
        flex-flow: row nowrap;
        padding: 1rem;
    }

    @media (max-width: 600px) and (orientation: landscape) {
        flex-flow: column nowrap;
    }

    @media(max-width: 799px) and (orientation: portrait) {
        flex-flow: column nowrap;
    }

    @media (max-width: 990px) and (orientation: landscape) {
        flex-flow: row nowrap;
    }
`;

export const VideoPlayer = styled.div`
    display: block;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    height: 40%;

    @media (min-width: 650px) {
        height: 100%;
        margin-bottom: 10px;
        padding: 0 20px 0 20px;
    }

    @media (max-width: 650px) {
        height: ${props => (props.isOnboarding ? '50%' : props.isChatEnabled && props.isLive ? '70%' : '100%')};
    }

    @media (max-width: 650px) and (orientation: landscape) {
        height: 100%;
    }

    @media (max-width: 320px) {
        max-height: 310px;  
    }

    .video-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 62px;
        padding: 10px;
        margin-bottom: 15px;
        background-color: #1c1b2d;
        min-height: 65px;

        span {
            height: 28px;
            border-radius: 3px;
            background-color: #ff5b7d;
            position: relative;
            text-transform: uppercase;
            color: #fff;
            font-weight: bold;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 5px 10px 5px 25px;
            min-width: 104px;

            &:before {
                content: "";
                position: absolute;
                height: 10px;
                width: 10px;
                background-color: #fff;
                left: 10px;
                border-radius: 50%;
            }
        }

        h5 {
            font-size: clamp(12px, 0.4em + 1vw, 1.5em);
            font-weight: 800;
            font-stretch: normal;
            line-height: normal;
            letter-spacing: 0.48px;
            color: #ffffff;
            flex: 1;
            text-align: center;
        }

        h6 {
            font-size: 12px;
            font-weight: bold;
            font-stretch: normal;
            line-height: normal;
            letter-spacing: 0.02px;
            color: #ffffff;
        }

        @media (max-width: 450px) {
            text-align: center;
            h5 {
                display: none;
            }
        }
        
        @media (max-width: 400px) {
            span {
                font-size: 10px;
                min-width: 80px;
            }
        }
    }

    .video-container {
        height: 100%;
        display: flex;
        flex-flow: column nowrap;
        justify-content: space-between;
        border-radius: 8px;
        background-color: #212032;
        overflow: hidden;
    }

    .video-details {
        max-height: 20rem;
        
        h5 {
            margin: 16px 8px 20px 12px;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.29;
            letter-spacing: 0.34px;
            color: #ffffff;
            position: relative;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            &::before {
                content: "";
                background-color: #ff985f;
                position: absolute;
                height: 100%;
                width: 4px;
                left: -14px;
                border-radius: 5px;
            }
        }
    }

    .video-player {
        overflow: hidden;
        position: relative;
        height: ${(props) => (props.collapsed
        ? 'calc(98% - 65px)'
        : props.hasAttachments
            ? '68%'
            : '100%')};
    }
    @media (max-width: 650px) {
        .video-player {
            height: ${(props) => (props.collapsed
        ? 'calc(98% - 45px)'
        : props.hasAttachments
            ? '68%'
            : '100%')};
        }
    }
`;

export const DescriptionContainer = styled.div`
    width: 100%;
    max-height: 13rem;
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
`;

export const Chat = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 300px;
    width: 25vw;
`;

export const MockVideo = styled.div`
    width: 100%;
    height: 100%;
    background-color: black;
    display: flex;
    justify-content: center;
    align-items: center;

    @media(max-width: 799px) {
        height: 20vh;
    }

`;
